import type { Tagged } from 'type-fest';

export type RelativeDOMRect = Tagged<DOMRect, 'RelativeDOMRect'>;

function toRelativeDOMRect(
  rect: DOMRect,
  containerRect: DOMRect,
): RelativeDOMRect {
  return DOMRect.fromRect({
    x: rect.x - containerRect.x,
    y: rect.y - containerRect.y,
    width: rect.width,
    height: rect.height,
  }) as RelativeDOMRect;
}

export default toRelativeDOMRect;
